import React, { useState, useEffect } from 'react';
import PageHeaderSkylink from '../../Components/common/PageHeaderSkylink'
import './NewsStyle.css'
import { useParams } from 'react-router-dom';
import { newscombine } from './newscombine';
import { fetchNewsBySlug } from '../../action/news';

function replaceAllOembedWithIframe(htmlString) {
    return htmlString.replace(
        /<oembed\s+url=["']([^"']+)["']\s*><\/oembed>/gi,
        (match, url) => {
            let embedUrl = url;

            // YouTube URL -> convert to embed format
            const ytMatch = url.match(
                /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
            );
            if (ytMatch) {
                const videoId = ytMatch[1];
                embedUrl = `https://www.youtube.com/embed/${videoId}`;
            }

            return `
<iframe width="560" height="315"
    src="${embedUrl}"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    title="Embedded media player">
</iframe>`;
        }
    );
}


const img_base_url = process.env.REACT_APP_API_NEXT_URL

const NewsDetail = () => {

    const { route } = useParams();

    // const [selectedImage, setSelectedImage] = useState(null);

    // const openModal = (image) => {
    //     setSelectedImage(image);
    // };

    // const closeModal = () => {
    //     setSelectedImage(null);
    // };

    const [newsContent, setNewsContent] = useState(null);
    useEffect(() => {
        const fetchNewsContent = async () => {
            const res = await fetchNewsBySlug(route);
            if (res?.content) {
                let updatedHtml = res?.content.replaceAll(
                    '/api/uploads/',
                    `${img_base_url}/api/uploads/`
                );
                updatedHtml = replaceAllOembedWithIframe(updatedHtml);
                setNewsContent(updatedHtml);
            } else {
                setNewsContent(null);
            }
        };

        fetchNewsContent();
    }, [route]);

    return (
        <div className="main_wrapper section">
            <PageHeaderSkylink
                routes={[
                    {
                        route: '/tin-tuc',
                        routeName: 'news'
                    }
                ]}
                pageName='news'
            />
            <div className="container">
                <div className="blog_details section">
                    {/* {newscombine(route, openModal, closeModal, selectedImage)} */}
                    {newsContent &&
                        <div >
                            <style jsx>{`img {height: auto;max-width: 100%;}`}</style>
                            <div
                                dangerouslySetInnerHTML={{ __html: newsContent }}
                            />
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default NewsDetail